import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../pages/components/AuthContext';
import {
  FACILITY_RESET_PASSWORD_ROUTE_PATH,
  LOGIN_ROUTE_PATH,
  TWO_FACTOR_AUTHENTICATION_ROUTE_PATH,
} from './RoutPath';
import { useEffect } from 'react';

const PrivateRoute = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const pendingMfaUser = sessionStorage.getItem('pendingMfaUser');

  useEffect(() => {
    if (!isAuthenticated && location.pathname !== LOGIN_ROUTE_PATH) {
      history.replaceState(null, '', LOGIN_ROUTE_PATH);
    }
  }, [isAuthenticated, location.pathname]);

  if (pendingMfaUser) {
    const pendingUser = JSON.parse(pendingMfaUser);
    if (pendingUser?.passwordChangeRequired) {
      return <Navigate to={FACILITY_RESET_PASSWORD_ROUTE_PATH} replace />;
    }
    if (pendingUser?.requiredMfa && !pendingUser?.passwordChangeRequired) {
      return <Navigate to={TWO_FACTOR_AUTHENTICATION_ROUTE_PATH} replace />;
    }
  }

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={LOGIN_ROUTE_PATH} replace />
  );
};

export default PrivateRoute;
